import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {
  Autocomplete,
  Button,
  ButtonGroup,
  Chip,
  ClickAwayListener,
  Collapse,
  Divider,
  Grid,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import Box from "@mui/material/Box";
import { format, parseISO } from "date-fns";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";

import {
  createItemApi,
  retrieveAllItemsApi,
  retrieveItemByIdApi,
  updateItemApi,
} from "../../../components/api/ItemApiService";
import {
  createSampleApi,
  retrievePurposeFilteredSamplesApi,
  retrieveSampleByIdApi,
  updateSampleApi,
} from "../../../components/api/SampleApiService";
import {
  retrieveFastStakeholdersApi,
  retrieveStakeholderByIdApi,
} from "../../../components/api/StakeholderApiService";
import { retrieveQuantityByItemIdApi } from "../../../components/api/QuantityApiService";
import FilterSelect from "../../../components/FilterSelect";

const options = ["New", "Edit"];

const AddVendorOffer = (props) => {
  const [vendor, setVendor] = useState([]);
  useEffect(() => {
    setItem({
      ...item,
      moisture: 12.5,
    });
    let dummyArr = [...addViewStatesArray];
    dummyArr[index] = {
      ...dummyArr[index],
      offerType: "VENDOR",
      volumeUnit: "KG",
      firstOfferPriceCurrency: "USD",
      finalOfferPriceCurrency: "USD",
      offerYear:
        addViewStatesArray[0]?.offerYear || new Date().getFullYear().toString(),
      offerGroupNumber:
        addViewStatesArray[0]?.offerGroupNumber || newOfferGroupNumber,
      orderGroupNumber: addViewStatesArray[0]?.orderGroupNumber,
      company: addViewStatesArray[0]?.company,
      paymentTerm: addViewStatesArray[0]?.paymentTerm,
      portOfLoading: addViewStatesArray[0]?.portOfLoading,
      portOfDischarge: addViewStatesArray[0]?.portOfDischarge,
      incoterm: addViewStatesArray[0]?.incoterm,
      offerLink: addViewStatesArray[0]?.offerLink,
      remark: addViewStatesArray[0]?.remark,
      offerDate: addViewStatesArray[0]?.offerDate,
      validityDate: addViewStatesArray[0]?.validityDate,
      stakeholderId: addViewStatesArray[0]?.stakeholderId,
      stakeholder: (addViewStatesArray[0]?.stakeholder ? addViewStatesArray[0]?.stakeholder :
        retrieveVendorById(
        addViewStatesArray[0]?.stakeholderId || 0,
      )),
    };
    setAddViewStatesArray([...dummyArr]);
  }, []);

  const portOfDischargeIncoterms = [
    "C&F",
    "CFR",
    "CIF",
    "CIP",
    "CPT",
    "DAP",
    "DDP",
    "DPU",
  ];
  const portOfLoadingIncoterms = ["EXW", "FAS", "FCA", "FOB"];
  const [quantity, setQuantity] = useState([]);
  const [items, setItems] = useState([]);
  const [vendors, setVendors] = useState([]);
  const currentYear = new Date().getFullYear().toString();
  const [isNewItemOpen, setIsNewItemOpen] = useState(false);
  const [isEditItemOpen, setIsEditItemOpen] = useState(false);
  const [item, setItem] = useState([]);
  const [isNewSampleOpen, setIsNewSampleOpen] = useState(false);
  const [isEditSampleOpen, setIsEditSampleOpen] = useState(false);
  const [sample, setSample] = useState([]);
  const [stakeholders, setStakeholders] = useState([]);
  const [filteredSamples, setFilteredSamples] = useState([]);
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const anchorRef = React.useRef(null);
  const anchorRef2 = React.useRef(null);
  const anchorRef3 = React.useRef(null);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selectedIndex2, setSelectedIndex2] = useState(0);
  const [selectedIndex3, setSelectedIndex3] = useState(0);

  const handleClick = () => {
    if (selectedIndex === 0) {
      setIsNewItemOpen(true);
      setIsEditItemOpen(false);
    } else {
      setIsEditItemOpen(true);
      setIsNewItemOpen(false);
      retrieveItemById(addViewStatesArray[index]?.itemId);
    }
  };
  const handleClick2 = () => {
    if (selectedIndex2 === 0) {
      setIsNewSampleOpen(true);
      setIsEditSampleOpen(false);
    } else {
      setIsEditSampleOpen(true);
      setIsNewSampleOpen(false);
      retrieveSampleById(addViewStatesArray[index]?.firstSampleId);
    }
  };
  const handleClick3 = () => {
    if (selectedIndex3 === 0) {
      setIsNewSampleOpen(true);
      setIsEditSampleOpen(false);
    } else {
      setIsEditSampleOpen(true);
      setIsNewSampleOpen(false);
      retrieveSampleById(addViewStatesArray[index]?.secondSampleId);
    }
  };

  const handleMenuItemClick = (event, index) => {
    setSelectedIndex(index);
    setOpen(false);
  };
  const handleMenuItemClick2 = (event, index) => {
    setSelectedIndex2(index);
    setOpen2(false);
  };
  const handleMenuItemClick3 = (event, index) => {
    setSelectedIndex3(index);
    setOpen3(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };
  const handleToggle2 = () => {
    setOpen2((prevOpen) => !prevOpen);
  };
  const handleToggle3 = () => {
    setOpen3((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };
  const handleClose2 = (event) => {
    if (anchorRef2.current && anchorRef2.current.contains(event.target)) {
      return;
    }

    setOpen2(false);
  };
  const handleClose3 = (event) => {
    if (anchorRef3.current && anchorRef3.current.contains(event.target)) {
      return;
    }

    setOpen3(false);
  };

  function retrieveQuantity(itemId) {
    retrieveQuantityByItemIdApi(itemId)
      .then((response) => {
        setQuantity(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

  function retrieveItems() {
    retrieveAllItemsApi()
      .then((response) => {
        setItems(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }
  function retrieveItemById(id) {
    retrieveItemByIdApi(id)
      .then((response) => {
        setItem(response?.data);
        console.log(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }
  function retrieveSampleById(id) {
    retrieveSampleByIdApi(id)
      .then((response) => {
        setSample(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

  function retrieveFilteredSamples(samplePurpose) {
    retrievePurposeFilteredSamplesApi(samplePurpose)
      .then((response) => {
        setFilteredSamples(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

  function retrieveVendors() {
    retrieveFastStakeholdersApi("VENDOR")
      .then((response) => {
        setVendors(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

  function retrieveStakeholders() {
    Promise.all([
      retrieveFastStakeholdersApi("VENDOR"),
      retrieveFastStakeholdersApi("CUSTOMER"),
    ])
      .then(([vendorResponse, customerResponse]) => {
        setStakeholders([...vendorResponse?.data, ...customerResponse?.data]);
      })
      .catch((error) => console.log(error.response?.data));
  }

  function retrieveVendorById(stakeholderId) {
    retrieveStakeholderByIdApi(stakeholderId)
      .then((response) => {
        setVendor(response?.data);
        return response?.data;
      })
      .catch((error) => console.log(error.response?.data));
  }

  const {
    offer,
    index,
    setAddViewStatesArray,
    addViewStatesArray,
    key,
    newOfferGroupNumber,
  } = props;

  setAddViewStatesArray[index]?.volumeUnit("KG");
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedVendor, setSelectedVendor] = useState(
    (addViewStatesArray[0]?.stakeholder ? addViewStatesArray[0]?.stakeholder 
      : addViewStatesArray[index]?.stakeholder ? addViewStatesArray[index]?.stakeholder
      : ""),
  );
  const [selectedFirstSample, setSelectedFirstSample] = useState(null);
  const [selectedSecondSample, setSelectedSecondSample] = useState(null);

  const handleShowHide = () => {
    let dummyArr = addViewStatesArray;
    dummyArr[index].show = !offer.show;
    setAddViewStatesArray([...dummyArr]);
  };

  const handleDelete = () => {
    let dummyArr = addViewStatesArray;
    dummyArr.splice(index, 1);
    setAddViewStatesArray([...dummyArr]);
  };

  return (
    <>
      <Grid
        container
        item
        xs={12}
        display={"flex"}
        justifyContent={"end"}
        gap={1}
      >
        <Button
          variant="outlined"
          size="small"
          sx={{ minWidth: "80px" }}
          onClick={() => handleShowHide()}
        >
          {offer.show ? "Hide" : "Show"}
        </Button>
        <Button
          variant="contained"
          size="small"
          sx={{ minWidth: "80px" }}
          onClick={() => handleDelete()}
        >
          Delete
        </Button>
      </Grid>
      <Collapse in={offer.show} key={key}>
        <Grid container xs={12} spacing="8px">
          <Grid item xs={2} sm={1.5}>
            <Typography variant="body2">Offer Year</Typography>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              defaultValue={addViewStatesArray[0]?.offerYear || currentYear}
              onChange={(e) => {
                let dummyArr = addViewStatesArray;
                dummyArr[index] = {
                  ...dummyArr[index],
                  offerYear: e.target.value,
                };
                setAddViewStatesArray([...dummyArr]);
              }}
            />
          </Grid>

       <Grid item xs={12} sm={2}></Grid>

          <Grid item xs={12} sm={2}>
            <Typography variant="body2">Buying Company</Typography>
              <FilterSelect
                   menuType="companies"
                   value={addViewStatesArray[index]?.company}
                   onChange={(e) => {
                     let dummyArr = addViewStatesArray;
                     dummyArr[index] = {
                       ...dummyArr[index],
                       company: e.target.value,
                     };
                     setAddViewStatesArray([...dummyArr]);
                   }}
                   fullWidth
                 />
          </Grid>

          <Grid item xs={12} sm={2}></Grid>

          <Grid item xs={12} sm={2}>
            <Typography variant="body2">SG Approval Status</Typography>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              select
              disabled
              label={"Not Approved"}
            >
            </TextField>
          </Grid>

          <Grid item xs={12} sm={2}></Grid>

          <Grid item xs={10} sm={1.5}>
            <Typography variant="body2">Offer Number</Typography>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              defaultValue={
                addViewStatesArray[0]?.offerGroupNumber || newOfferGroupNumber
              }
              onChange={(e) => {
                let dummyArr = addViewStatesArray;
                dummyArr[index] = {
                  ...dummyArr[index],
                  offerGroupNumber: e.target.value,
                };
                setAddViewStatesArray([...dummyArr]);
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6}></Grid>
          
          <Grid item xs={12} sm={2}>
            <Typography variant="body2">Record Status</Typography>
            <TextField
              id="outlined-select-status"
              select
              variant="outlined"
              size="small"
              fullWidth
              label={"ACTIVE"}
              disabled
            >
            </TextField>
          </Grid>

          <Grid item xs={12} sm={2}></Grid>

          <Grid item xs={12} sm={1.5}>
            <Typography variant="body2">Offer Date</Typography>
            <TextField
              size="small"
              fullWidth
              variant="outlined"
              id="date"
              type="date"
              defaultValue={addViewStatesArray[0]?.offerDate}
              inputProps={{ min: "1999-01-01", max: new Date().toISOString().split("T")[0], }}
              InputLabelProps={{
                shrink: true,
              }}
              onKeyDown={(e) => e.preventDefault()}
              error={!addViewStatesArray[index]?.offerDate}
              helperText={!addViewStatesArray[index]?.offerDate ? "Offer date is required" : ""}
              onChange={(e) => {
                let dummyArr = addViewStatesArray;
                dummyArr[index] = {
                  ...dummyArr[index],
                  offerDate: e.target.value,
                };
                setAddViewStatesArray([...dummyArr]);
              }}
            />
          </Grid>

          <Grid item xs={12} sm={2}></Grid>

          <Grid item xs={12} sm={3}>
            <Typography variant="body2">Vendor</Typography>
            <Autocomplete
              options={vendors}
              getOptionLabel={(option) =>
                `${option?.id || ""} - ${option?.name || ""}`
              }
              value={selectedVendor || vendor}
              onChange={(event, newValue) => {
                setSelectedVendor(newValue);

                let dummyArr = addViewStatesArray;
                dummyArr[index] = {
                  ...dummyArr[index],
                  stakeholder: newValue ? newValue : {},
                  stakeholderId: newValue ? newValue.id : null,
                };
                setAddViewStatesArray([...dummyArr]);
              }}
              onOpen={retrieveVendors}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  size="small"
                  fullWidth
                />
              )}
              renderTags={() => null}
            />
          </Grid>

          <Grid item xs={12} sm={1}></Grid>

          <Grid item xs={12} sm={2}>
            <Typography variant="body2">Status</Typography>
            <FilterSelect
                          menuType="offerStatus"
                          value={addViewStatesArray[index]?.status || ""}
                          onChange={(e) => {
                            let dummyArr = addViewStatesArray;
            
                            const newStatus = e.target.value;
                            let newStatusDeadline = dummyArr[index]?.statusDeadline;
                            if (newStatus !== "First Refusal" || newStatus !== "Optioned") {
                              newStatusDeadline = null;
                            }
                            dummyArr[index] = {
                              ...dummyArr[index],
                              status: newStatus,
                              statusDeadline: newStatusDeadline,
                            };
                            setAddViewStatesArray([...dummyArr]);
                          }}
                          fullWidth
                        />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Typography variant="body2">Status Deadline</Typography>
            <TextField
              size="small"
              fullWidth
              disabled={
                addViewStatesArray[index]?.status !== "First Refusal" &&
                addViewStatesArray[index]?.status !== "Optioned"
              }
              variant="outlined"
              id="date"
              type="date"
              onKeyDown={(e) => e.preventDefault()}
              inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
              InputLabelProps={{
                shrink: true,
              }}
              error={
                (!addViewStatesArray[index]?.statusDeadline ||
                  addViewStatesArray[index]?.statusDeadline === "") &&
                (addViewStatesArray[index]?.status === "First Refusal" ||
                  addViewStatesArray[index]?.status === "Optioned")
              }
              helperText={
                (!addViewStatesArray[index]?.statusDeadline ||
                  addViewStatesArray[index]?.statusDeadline === "") &&
                  (addViewStatesArray[index]?.status === "First Refusal" ||
                    addViewStatesArray[index]?.status === "Optioned")
                  ? "Status deadline is required for this status."
                  : ""
              }
              onChange={(e) => {
                let dummyArr = addViewStatesArray;
                dummyArr[index] = {
                  ...dummyArr[index],
                  statusDeadline: e.target.value,
                };
                setAddViewStatesArray([...dummyArr]);
              }}
            />
          </Grid>

          <Grid item xs={12} sm={1.5}>
            <Typography variant="body2">Validity Date</Typography>
            <TextField
              size="small"
              fullWidth
              variant="outlined"
              id="date"
              type="date"
              defaultValue={addViewStatesArray[0]?.validityDate}
              inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
              InputLabelProps={{
                shrink: true,
              }}
              onKeyDown={(e) => e.preventDefault()}
              onChange={(e) => {
                let dummyArr = addViewStatesArray;
                dummyArr[index] = {
                  ...dummyArr[index],
                  validityDate: e.target.value,
                };
                setAddViewStatesArray([...dummyArr]);
              }}
            />
          </Grid>

          <Grid item xs={12} sm={2}></Grid>

          <Grid item xs={12} sm={2}>
            <Typography variant="body2">SAP Vendor Code</Typography>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              value={selectedVendor?.code || ""}
              disabled
            />
          </Grid>

          <Grid item xs={12} sm={2}></Grid>

          <Grid item xs={12} sm={4}>
            <Typography variant="body2">Offer Link</Typography>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              defaultValue={addViewStatesArray[0]?.offerLink}
              onChange={(e) => {
                let dummyArr = addViewStatesArray;
                dummyArr[index] = {
                  ...dummyArr[index],
                  offerLink: e.target.value,
                };
                setAddViewStatesArray([...dummyArr]);
              }}
            />
          </Grid>

  <Grid item xs={12}>
            <Divider
              sx={{
                "&.MuiDivider-root": {
                  margin: "10px 0",
                  borderColor: "#1890ff",
                },
              }}
            />
          </Grid>

          <TableContainer component={Paper}
           sx={{
            border: "2px solid #d1dfe8",
            borderRadius: "8px", 
            overflow: "hidden", 
          }}>

      <Table   sx={{
      borderCollapse: "separate", 
      borderSpacing: "0", 
      tableLayout: "fixed",
      width: "100%", 
    }}>
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: "15%", border: "1px solid #d1dfe8",
            backgroundColor: "#98c1d9",
            fontSize: "0.7rem", 
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
              Item
            </TableCell>
            <TableCell sx={{ width: "5%", border: "1px solid #d1dfe8",
             backgroundColor: "#98c1d9",
            fontSize: "0.7rem", 
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
              ID
            </TableCell>
            <TableCell sx={{ width: "10%", border: "1px solid #d1dfe8",
             backgroundColor: "#98c1d9",
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
              Buying Grade
            </TableCell>
            <TableCell sx={{ width: "10%", border: "1px solid #d1dfe8",
            backgroundColor: "#98c1d9",
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
              Internal Grade
            </TableCell>
            <TableCell sx={{ width: "8%", border: "1px solid #d1dfe8",
            backgroundColor: "#98c1d9",
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
              Type
            </TableCell>
            <TableCell sx={{ width: "10%", border: "1px solid #d1dfe8",
            backgroundColor: "#98c1d9",
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
              Origin
            </TableCell>
            {selectedItem?.origin==="China" && <TableCell sx={{ width: "10%", border: "1px solid #d1dfe8",
            backgroundColor: "#98c1d9",
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
              Province
            </TableCell>}
            <TableCell sx={{ width: "6%", border: "1px solid #d1dfe8",
            backgroundColor: "#98c1d9",
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
              Crop
            </TableCell>
            <TableCell sx={{ width: "6%", border: "1px solid #d1dfe8",
            backgroundColor: "#98c1d9",
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
              Nicotine
            </TableCell>
            <TableCell sx={{ width: "6%", border: "1px solid #d1dfe8",
            backgroundColor: "#98c1d9",
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
              Sugar
            </TableCell>
            <TableCell sx={{ width: "6%", border: "1px solid #d1dfe8",
            backgroundColor: "#98c1d9",
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
              Moisture
            </TableCell>
            <TableCell sx={{ width: "6%", border: "1px solid #d1dfe8",
            backgroundColor: "#98c1d9",
            fontSize: "0.7rem", 
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
              Current Location
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell sx={{ border: "1px solid #d1dfe8" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                flexWrap: "nowrap",
              }}
            >
            <Grid container xs={12} spacing="8px">
              <Grid item xs={12} sm={8}>
                <Autocomplete
                  options={items}
                  getOptionLabel={(option) =>
                    `${option?.id || ""} - Buying Grade: ${option?.buyingGrade || ""
                    } - ${option?.origin || ""} - ${option?.crop || ""}`
                  }
                  value={selectedItem}
                  onChange={(event, newValue) => {
                    setSelectedItem(newValue);
                    let dummyArr = addViewStatesArray;
                    dummyArr[index] = {
                      ...dummyArr[index],
                      item: newValue ? newValue : {},
                      itemId: newValue ? newValue.id : null,
                      itemStorage: newValue?.storage || "",
                      salesGrade: newValue?.salesGrade || "",
                    };
                    setAddViewStatesArray([...dummyArr]);
                    retrieveQuantity(newValue?.id);
                  }}
                  onOpen={retrieveItems}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      size="small"
                      fullWidth
                    />
                  )}
                  renderTags={() => null}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <ButtonGroup
                  variant="outlined"
                  ref={anchorRef}
                  aria-label="Button group with a nested menu"
                >
                  <Button onClick={handleClick}>
                    {options[selectedIndex]}
                  </Button>
                  <Button
                    size="small"
                    aria-controls={open ? "split-button-menu" : undefined}
                    aria-expanded={open ? "true" : undefined}
                    aria-label="select merge strategy"
                    aria-haspopup="menu"
                    onClick={handleToggle}
                    sx={{
                      width: "20px !important",
                      minWidth: "0px !important",
                    }}
                  >
                    <ArrowDropDownIcon />
                  </Button>
                </ButtonGroup>
                <Popper
                  sx={{
                    zIndex: 1,
                  }}
                  open={open}
                  anchorEl={anchorRef.current}
                  role={undefined}
                  transition
                  disablePortal
                >
                  {({ TransitionProps, placement }) => (
                    <Grow
                      {...TransitionProps}
                      style={{
                        transformOrigin:
                          placement === "bottom"
                            ? "center top"
                            : "center bottom",
                      }}
                    >
                      <Paper>
                        <ClickAwayListener onClickAway={handleClose}>
                          <MenuList id="split-button-menu" autoFocusItem>
                            {options.map((option, index) => (
                              <MenuItem
                                key={option}
                                disabled={index === 2}
                                selected={index === selectedIndex}
                                onClick={(event) =>
                                  handleMenuItemClick(event, index)
                                }
                              >
                                {option}
                              </MenuItem>
                            ))}
                          </MenuList>
                        </ClickAwayListener>
                      </Paper>
                    </Grow>
                  )}
                </Popper>
              </Grid>
            </Grid>
          
            </Box>
            </TableCell>

            <TableCell sx={{ border: "1px solid #d1dfe8" }}>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                disabled
                value={(selectedItem?.id || "")}
              />
            </TableCell>

            <TableCell sx={{ border: "1px solid #d1dfe8" }}>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                disabled
                value={
                  selectedItem?.buyingGrade || ""
                }
              />
            </TableCell>

            <TableCell sx={{ border: "1px solid #d1dfe8" }}>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                disabled
                value={
                  selectedItem?.internalGrade || ""
                }
              />
            </TableCell>

            <TableCell sx={{ border: "1px solid #d1dfe8" }}>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                disabled
                value={
                  selectedItem?.type || ""
                }
              />
            </TableCell>

            <TableCell sx={{ border: "1px solid #d1dfe8" }}>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                disabled
                value={
                  selectedItem?.origin || ""
                }
              />
            </TableCell>

            {selectedItem?.origin==="China" && <TableCell sx={{ border: "1px solid #d1dfe8" }}>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                disabled
                value={
                  selectedItem?.province || ""
                }
              />
            </TableCell>}

            <TableCell sx={{ border: "1px solid #d1dfe8" }}>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                disabled
                value={
                  selectedItem?.crop || ""
                }
              />
            </TableCell>
            <TableCell sx={{ border: "1px solid #d1dfe8" }}>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                disabled
                value={
                  selectedItem?.nicotine || ""
                }
              />
            </TableCell>
            <TableCell sx={{ border: "1px solid #d1dfe8" }}>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                disabled
                value={
                  selectedItem?.sugar || ""
                }
              />
            </TableCell>
            <TableCell sx={{ border: "1px solid #d1dfe8" }}>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                disabled
                value={
                  selectedItem?.moisture || ""
                }
              />
            </TableCell>

            <TableCell sx={{ border: "1px solid #d1dfe8" }}>
            <TextField
              variant="outlined"
              size="small"
              value={addViewStatesArray[index]?.itemStorage || ""}
              fullWidth
              onChange={(e) => {
                let dummyArr = addViewStatesArray;
                dummyArr[index] = {
                  ...dummyArr[index],
                  itemStorage: e.target.value,
                };
                setAddViewStatesArray([...dummyArr]);
              }}
            />
          </TableCell>

          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>

   <Grid item xs={12} sm={12}></Grid>
          <Grid item xs={12} sm={12}></Grid>

          <TableContainer component={Paper}
           sx={{
            border: "2px solid #d1dfe8",
            borderRadius: "8px", 
            overflow: "hidden", 
          }}>

      <Table   sx={{
      borderCollapse: "separate", 
      borderSpacing: "0", 
      tableLayout: "fixed",
      width: "100%", 
    }}>
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: "10%", border: "1px solid #d1dfe8",
            backgroundColor: "#98c1d9",
            fontSize: "0.7rem", 
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
              Offer Sample
            </TableCell>
            <TableCell sx={{ width: "3%", border: "1px solid #d1dfe8",
             backgroundColor: "#98c1d9",
            fontSize: "0.7rem", 
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
              ID
            </TableCell>
            <TableCell sx={{ width: "10%", border: "1px solid #d1dfe8",
             backgroundColor: "#98c1d9",
            fontSize: "0.7rem", 
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
             Offer Sample Remark
            </TableCell>
            <TableCell sx={{ width: "5%", border: "1px solid #d1dfe8",
             backgroundColor: "#98c1d9",
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
              Offer Sample Status
            </TableCell>
            <TableCell sx={{ width: "10%", border: "1px solid #d1dfe8",
            backgroundColor: "#98c1d9",
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
              Trial Sample
            </TableCell>
            <TableCell sx={{ width: "3%", border: "1px solid #d1dfe8",
             backgroundColor: "#98c1d9",
            fontSize: "0.7rem", 
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
               ID
            </TableCell>
            <TableCell sx={{ width: "10%", border: "1px solid #d1dfe8",
             backgroundColor: "#98c1d9",
            fontSize: "0.7rem", 
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
              Trial Sample Remark
            </TableCell>
            <TableCell sx={{ width: "5%", border: "1px solid #d1dfe8",
            backgroundColor: "#98c1d9",
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
              Trial Sample Status
            </TableCell>
         </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell sx={{ border: "1px solid #d1dfe8" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                flexWrap: "nowrap",
              }}
            >

            <Grid container xs={12} spacing="8px">
              <Grid item xs={12} sm={8}>
                <Autocomplete
                  options={filteredSamples}
                  getOptionLabel={(option) =>
                    `ID: ${option?.id || ""}, Remark: ${option?.remark || ""
                    }, Buying Grade: ${option?.item?.buyingGrade || ""}`
                  }
                  value={selectedFirstSample}
                  onChange={(event, newValue) => {
                    setSelectedFirstSample(newValue);

                    let dummyArr = addViewStatesArray;
                    dummyArr[index] = {
                      ...dummyArr[index],
                      firstSample: newValue ? newValue : {},
                      firstSampleId: newValue ? newValue.id : null,
                    };
                    setAddViewStatesArray([...dummyArr]);
                  }}
                  onOpen={() => retrieveFilteredSamples("Offer Sample")}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      size="small"
                      fullWidth
                    />
                  )}
                  renderTags={() => null}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <ButtonGroup
                  variant="outlined"
                  ref={anchorRef2}
                  aria-label="Button group with a nested menu"
                >
                  <Button onClick={handleClick2}>
                    {options[selectedIndex2]}
                  </Button>
                  <Button
                    size="small"
                    aria-controls={open2 ? "split-button-menu" : undefined}
                    aria-expanded={open2 ? "true" : undefined}
                    aria-label="select merge strategy"
                    aria-haspopup="menu"
                    onClick={handleToggle2}
                    sx={{
                      width: "20px !important",
                      minWidth: "0px !important",
                    }}
                  >
                    <ArrowDropDownIcon />
                  </Button>
                </ButtonGroup>
                <Popper
                  sx={{
                    zIndex: 1,
                  }}
                  open={open2}
                  anchorEl={anchorRef2.current}
                  role={undefined}
                  transition
                  disablePortal
                >
                  {({ TransitionProps, placement }) => (
                    <Grow
                      {...TransitionProps}
                      style={{
                        transformOrigin:
                          placement === "bottom"
                            ? "center top"
                            : "center bottom",
                      }}
                    >
                      <Paper>
                        <ClickAwayListener onClickAway={handleClose2}>
                          <MenuList id="split-button-menu" autoFocusItem>
                            {options.map((option, index) => (
                              <MenuItem
                                key={option}
                                disabled={index === 2}
                                selected={index === selectedIndex2}
                                onClick={(event) =>
                                  handleMenuItemClick2(event, index)
                                }
                              >
                                {option}
                              </MenuItem>
                            ))}
                          </MenuList>
                        </ClickAwayListener>
                      </Paper>
                    </Grow>
                  )}
                </Popper>
              </Grid>
            </Grid>


          
            </Box>
            </TableCell>

            <TableCell sx={{ border: "1px solid #d1dfe8" }}>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                disabled
                value={(selectedFirstSample?.id || "")}
              />
            </TableCell>

            <TableCell sx={{ border: "1px solid #d1dfe8" }}>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                disabled
                value={(selectedFirstSample?.remark || "")}
              />
            </TableCell>

            <TableCell sx={{ border: "1px solid #d1dfe8" }}>
              <FilterSelect
                   menuType="sampleStatus"
                   value={addViewStatesArray[index]?.firstSampleStatus}
                   onChange={(e) => {
                    let dummyArr = addViewStatesArray;
                dummyArr[index] = {
                  ...dummyArr[index],
                  firstSampleStatus: e.target.value,
                };
                setAddViewStatesArray([...dummyArr]);
                   }}
                   fullWidth
                 />
            </TableCell>

            <TableCell sx={{ border: "1px solid #d1dfe8" }}>
            <Grid container xs={12} spacing="8px">
              <Grid item xs={12} sm={8}>
                <Autocomplete
                  options={filteredSamples}
                  getOptionLabel={(option) =>
                    `ID: ${option?.id || ""}, Remark: ${option?.remark || ""
                    }, Buying Grade: ${option?.item?.buyingGrade || ""}`
                  }
                  value={selectedSecondSample}
                  onChange={(event, newValue) => {
                    setSelectedSecondSample(newValue);

                    let dummyArr = addViewStatesArray;
                    dummyArr[index] = {
                      ...dummyArr[index],
                      secondSample: newValue ? newValue : {},
                      secondSampleId: newValue ? newValue.id : null,
                    };
                    setAddViewStatesArray([...dummyArr]);
                  }}
                  onOpen={() => retrieveFilteredSamples("Trial Sample")}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      size="small"
                      fullWidth
                    />
                  )}
                  renderTags={() => null}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <ButtonGroup
                  variant="outlined"
                  ref={anchorRef3}
                  aria-label="Button group with a nested menu"
                >
                  <Button onClick={handleClick3}>
                    {options[selectedIndex3]}
                  </Button>
                  <Button
                    size="small"
                    aria-controls={open3 ? "split-button-menu" : undefined}
                    aria-expanded={open3 ? "true" : undefined}
                    aria-label="select merge strategy"
                    aria-haspopup="menu"
                    onClick={handleToggle3}
                    sx={{
                      width: "20px !important",
                      minWidth: "0px !important",
                    }}
                  >
                    <ArrowDropDownIcon />
                  </Button>
                </ButtonGroup>
                <Popper
                  sx={{
                    zIndex: 1,
                  }}
                  open={open3}
                  anchorEl={anchorRef3.current}
                  role={undefined}
                  transition
                  disablePortal
                >
                  {({ TransitionProps, placement }) => (
                    <Grow
                      {...TransitionProps}
                      style={{
                        transformOrigin:
                          placement === "bottom"
                            ? "center top"
                            : "center bottom",
                      }}
                    >
                      <Paper>
                        <ClickAwayListener onClickAway={handleClose3}>
                          <MenuList id="split-button-menu" autoFocusItem>
                            {options.map((option, index) => (
                              <MenuItem
                                key={option}
                                disabled={index === 2}
                                selected={index === selectedIndex3}
                                onClick={(event) =>
                                  handleMenuItemClick3(event, index)
                                }
                              >
                                {option}
                              </MenuItem>
                            ))}
                          </MenuList>
                        </ClickAwayListener>
                      </Paper>
                    </Grow>
                  )}
                </Popper>
              </Grid>
            </Grid>
            </TableCell>

            <TableCell sx={{ border: "1px solid #d1dfe8" }}>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                disabled
                value={(selectedSecondSample?.id || "")}
              />
            </TableCell>

            <TableCell sx={{ border: "1px solid #d1dfe8" }}>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                disabled
                value={(selectedSecondSample?.remark || "")}
              />
            </TableCell>

          <TableCell sx={{ border: "1px solid #d1dfe8" }}>
             <FilterSelect
                   menuType="sampleStatus"
                   value={addViewStatesArray[index]?.secondSampleStatus}
                   onChange={(e) => {
                     let dummyArr = addViewStatesArray;
                dummyArr[index] = {
                  ...dummyArr[index],
                  secondSampleStatus: e.target.value,
                };
                setAddViewStatesArray([...dummyArr]);
                   }}
                   fullWidth
                 />
          </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>

<Grid item xs={12} sm={12}></Grid>
          <Grid item xs={12} sm={12}></Grid>

          <TableContainer component={Paper}
           sx={{
            border: "2px solid #abcfff",
            borderRadius: "8px", 
            overflow: "hidden", 
          }}>

      <Table   sx={{
      borderCollapse: "separate", 
      borderSpacing: "0", 
      tableLayout: "fixed",
      width: "100%", 
    }}>
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: "9.5%", border: "1px solid #e0dada",
            backgroundColor: "#d7e7fc",
            fontSize: "0.7rem", 
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
              Net Weight Per Carton
            </TableCell>
            <TableCell sx={{ width: "9.5%", border: "1px solid #e0dada",
             backgroundColor: "#d7e7fc",
            fontSize: "0.7rem", 
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
              Number Of Cartons
            </TableCell>
            <TableCell sx={{ width: "10.5%", border: "1px solid #e0dada",
             backgroundColor: "#d7e7fc",
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
              Volume
            </TableCell>
            <TableCell sx={{ width: "9%", border: "1px solid #e0dada",
            backgroundColor: "#d7e7fc",
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
              Unit
            </TableCell>
            <TableCell sx={{ width: "9.5%", border: "1px solid #e0dada",
            backgroundColor: "#d7e7fc",
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
              Packaging
            </TableCell>
            <TableCell
        sx={{
          width: "19%",
          border: "1px solid #e0dada",
          backgroundColor: "#d7e7fc",
          fontSize: "0.7rem",
          padding: "4px 8px",
          whiteSpace: "nowrap",
          textAlign: "center",
        }}
      >
        Port Of Discharge
      </TableCell>
      <TableCell
        sx={{
          width: "19%",
          border: "1px solid #e0dada",
          backgroundColor: "#d7e7fc",
          fontSize: "0.7rem",
          padding: "4px 8px",
          whiteSpace: "nowrap",
          textAlign: "center",
        }}
      >
        Port Of Loading
      </TableCell> 
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>

          <TableCell sx={{ border: "1px solid #e0dada" }}>
            <Typography variant="body2">Net Weight Per Carton</Typography>
            <TextField
              type="number"
              variant="outlined"
              size="small"
              fullWidth
              onWheel={(e) => e.target.blur()}
              onChange={(e) => {
                let dummyArr = addViewStatesArray;
                dummyArr[index] = {
                  ...dummyArr[index],
                  netWeightPerCase: e.target.value,
                  volume:
                    e.target.value * addViewStatesArray[index]?.numberOfCases,
                };
                setAddViewStatesArray([...dummyArr]);
              }}
            />
          </TableCell>

           <TableCell sx={{ border: "1px solid #e0dada" }}>
            <Typography variant="body2">Number Of Cartons</Typography>
            <TextField
              type="number"
              variant="outlined"
              size="small"
              fullWidth
              onWheel={(e) => e.target.blur()}
              onChange={(e) => {
                let dummyArr = addViewStatesArray;
                dummyArr[index] = {
                  ...dummyArr[index],
                  numberOfCases: e.target.value,
                  volume:
                    e.target.value *
                    addViewStatesArray[index]?.netWeightPerCase,
                };
                setAddViewStatesArray([...dummyArr]);
              }}
            />
          </TableCell>
          <TableCell sx={{ border: "1px solid #e0dada" }}>
            <Typography variant="body2">Enter Volume</Typography>
            <TextField
              type="number"
              variant="outlined"
              size="small"
              value={addViewStatesArray[index]?.volume}
              fullWidth
              onWheel={(e) => e.target.blur()}
              onChange={(e) => {
                let dummyArr = addViewStatesArray;
                dummyArr[index] = {
                  ...dummyArr[index],
                  volume: e.target.value,
                };
                setAddViewStatesArray([...dummyArr]);
              }}
            />
          </TableCell>
          <TableCell sx={{ border: "1px solid #e0dada" }}>
            <Typography variant="body2">Select Volume Unit</Typography>
             <FilterSelect
                    menuType="unit"
                    value={addViewStatesArray[index]?.volumeUnit}
                    onChange={(e) => {
                      let dummyArr = addViewStatesArray;
                      dummyArr[index] = {
                        ...dummyArr[index],
                        volumeUnit: e.target.value,
                      };
                      setAddViewStatesArray([...dummyArr]);
                    }}
                    fullWidth
                  />
            </TableCell>

            <TableCell sx={{ border: "1px solid #e0dada" }}>
            <Typography variant="body2"> Packaging</Typography>
              <FilterSelect
                 menuType="packagingTypes"
                 value={addViewStatesArray[index]?.packaging}
                 onChange={(e) => {
                   let dummyArr = addViewStatesArray;
                dummyArr[index] = {
                  ...dummyArr[index],
                  packaging: e.target.value,
                };
                setAddViewStatesArray([...dummyArr]);
                 }}
                 fullWidth
               />
            </TableCell>

            <TableCell sx={{ border: "1px solid #e0dada" }}>
            <Typography variant="body2">Port Of Discharge</Typography>
              <FilterSelect
                 menuType="portsOfDischarge"
                 value={addViewStatesArray[index]?.portOfDischarge || ""}
                 onChange={(e) => {
                        const newTerm = e.target.value || "";
                        let dummyArr = addViewStatesArray;
                        dummyArr[index] = {
                          ...dummyArr[index],
                          portOfDischarge: newTerm,
                        };
                        setAddViewStatesArray([...dummyArr]);
                      }}
                 fullWidth
                 sx={{
                    border:
                      portOfDischargeIncoterms.includes(
                        addViewStatesArray[index]?.incoterm,
                      ) &&
                        (addViewStatesArray[index]?.portOfDischarge == null ||
                          addViewStatesArray[index]?.portOfDischarge === "")
                        ? "3px solid red"
                        : "none",
                    borderRadius:
                      portOfDischargeIncoterms.includes(
                        addViewStatesArray[index]?.incoterm,
                      ) &&
                        (addViewStatesArray[index]?.portOfDischarge == null ||
                          addViewStatesArray[index]?.portOfDischarge === "")
                        ? "5px"
                        : "none",
                  }}
               />
          </TableCell>

          <TableCell sx={{ border: "1px solid #e0dada" }}>
            <Typography variant="body2">Port Of Loading</Typography>
                <FilterSelect
                   menuType="portsOfLoading"
                   value={addViewStatesArray[index]?.portOfLoading || ""}
                   onChange={(e) => {
                     const newTerm = e.target.value || "";
                let dummyArr = addViewStatesArray;
                dummyArr[index] = {
                  ...dummyArr[index],
                  portOfLoading: newTerm,
                };
                setAddViewStatesArray([...dummyArr]);
                   }}
                   fullWidth
                   sx={{
                    border:
                      portOfLoadingIncoterms.includes(
                        addViewStatesArray[index]?.incoterm,
                      ) &&
                        (addViewStatesArray[index]?.portOfLoading == null ||
                          addViewStatesArray[index]?.portOfLoading === "")
                        ? "3px solid red"
                        : "none",
                    borderRadius:
                      portOfLoadingIncoterms.includes(
                        addViewStatesArray[index]?.incoterm,
                      ) &&
                        (addViewStatesArray[index]?.portOfLoading == null ||
                          addViewStatesArray[index]?.portOfLoading === "")
                        ? "5px"
                        : "none",
                  }}
                 />
          </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      <Box sx={{ marginTop: "16px" }}></Box>

      <Table   sx={{
      borderCollapse: "separate", 
      borderSpacing: "0", 
      tableLayout: "fixed",
      width: "100%", 
    }}>
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: "9%", border: "1px solid #e0dada",
            backgroundColor: "#d7e7fc",
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
              First Price
            </TableCell>
            <TableCell sx={{ width: "6%", border: "1px solid #e0dada",
            backgroundColor: "#d7e7fc",
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
              Currency
            </TableCell>
            <TableCell sx={{ width: "9%", border: "1px solid #e0dada",
            backgroundColor: "#d7e7fc",
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
              Final Price
            </TableCell>
            <TableCell sx={{ width: "6%", border: "1px solid #e0dada",
            backgroundColor: "#d7e7fc",
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
              Currency
            </TableCell>
            <TableCell sx={{ width: "10%", border: "1px solid #e0dada",
            backgroundColor: "#d7e7fc",
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
              Incoterm
            </TableCell>
            <TableCell sx={{ width: "19%", border: "1px solid #e0dada",
            backgroundColor: "#d7e7fc",
            padding: "4px 8px", 
            whiteSpace: "nowrap",
            textAlign: "center", }}>
              Payment Term
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>    
            <TableCell sx={{ border: "1px solid #e0dada" }}>
            <Typography variant="body2">Enter First Offer Price</Typography>
            <TextField
              type="number"
              variant="outlined"
              size="small"
              fullWidth
              onWheel={(e) => e.target.blur()}
              onChange={(e) => {
                let dummyArr = addViewStatesArray;
                dummyArr[index] = {
                  ...dummyArr[index],
                  firstOfferPrice: e.target.value,
                  finalOfferPrice: e.target.value,
                };
                setAddViewStatesArray([...dummyArr]);
              }}
            />
           </TableCell>

          <TableCell sx={{ border: "1px solid #e0dada" }}>
            <Typography variant="body2">Select First Offer Currency</Typography>
            <FilterSelect
                     menuType="currencies"
                     value={addViewStatesArray[index]?.firstOfferPriceCurrency || ""}
                     onChange={(e) => {
                        let dummyArr = addViewStatesArray;
                dummyArr[index] = {
                  ...dummyArr[index],
                  firstOfferPriceCurrency: e.target.value,
                  finalOfferPriceCurrency: e.target.value,
                };
                setAddViewStatesArray([...dummyArr]);
                     }}
                     fullWidth
                   />
            </TableCell>

            <TableCell sx={{ border: "1px solid #e0dada" }}>
            <Typography variant="body2"> Final Offer Price</Typography>
            <TextField
              type="number"
              variant="outlined"
              size="small"
              fullWidth
              value={addViewStatesArray[index]?.finalOfferPrice}
              onWheel={(e) => e.target.blur()}
              onChange={(e) => {
                let dummyArr = addViewStatesArray;
                dummyArr[index] = {
                  ...dummyArr[index],
                  finalOfferPrice: e.target.value,
                };
                setAddViewStatesArray([...dummyArr]);
              }}
            />
          </TableCell>
          <TableCell sx={{ border: "1px solid #e0dada" }}>
            <Typography variant="body2"> Final Offer Currency</Typography>
            <FilterSelect
                    menuType="currencies"
                    value={addViewStatesArray[index]?.finalOfferPriceCurrency}
                    onChange={(e) => {
                       let dummyArr = addViewStatesArray;
                dummyArr[index] = {
                  ...dummyArr[index],
                  finalOfferPriceCurrency: e.target.value,
                };
                setAddViewStatesArray([...dummyArr]);
                    }}
                    fullWidth
                  />
            </TableCell>

            <TableCell sx={{ border: "1px solid #e0dada" }}>
            <Typography variant="body2"> Incoterm</Typography>
             <FilterSelect
                   menuType="incoterms"
                   value={addViewStatesArray[index]?.incoterm}
                   onChange={(e) => {
                      let dummyArr = addViewStatesArray;
                      dummyArr[index] = {
                        ...dummyArr[index],
                        incoterm: e.target.value,
                      };
                      setAddViewStatesArray([...dummyArr]);
                   }}
                   fullWidth
                 />
            </TableCell>

            <TableCell sx={{ border: "1px solid #e0dada" }}>
            <Typography variant="body2"> Payment Term</Typography>
            <FilterSelect
                  menuType="paymentTerm"
                  value={addViewStatesArray[index]?.paymentTerm}
                  onChange={(e) => {
                    const newTerm = e.target.value || "";
                let dummyArr = addViewStatesArray;
                dummyArr[index] = {
                  ...dummyArr[index],
                  paymentTerm: newTerm,
                };
                setAddViewStatesArray([...dummyArr]);
                  }}
                  fullWidth
                />
          </TableCell>

          </TableRow>
        </TableBody>
      </Table>

      <Box sx={{ marginTop: "16px" }}></Box>

<Table
 sx={{
  borderCollapse: "separate", // Allows borderRadius to work
  borderSpacing: "0", // Removes unwanted spacing between cells
  tableLayout: "fixed",
  width: "100%", // Ensures the table takes full width
}}
>
  <TableHead>
    <TableRow>
      <TableCell
        sx={{
          width: "31%",
          border: "1px solid #e0dada",
          backgroundColor: "#d7e7fc",
          fontSize: "0.7rem",
          padding: "4px 8px",
          whiteSpace: "nowrap",
          textAlign: "center",
        }}
      >
        Remark
      </TableCell>
      <TableCell
        sx={{
          width: "31%",
          border: "1px solid #e0dada",
          backgroundColor: "#d7e7fc",
          fontSize: "0.7rem",
          padding: "4px 8px",
          whiteSpace: "nowrap",
          textAlign: "center",
        }}
      >
        Comment
      </TableCell>
    </TableRow>
  </TableHead>
  <TableBody>
    <TableRow>
     <TableCell sx={{ border: "1px solid #e0dada" }}>
            <Typography variant="body2"> Remark</Typography>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              defaultValue={addViewStatesArray[0]?.remark}
              onChange={(e) => {
                let dummyArr = addViewStatesArray;
                dummyArr[index] = {
                  ...dummyArr[index],
                  remark: e.target.value,
                };
                setAddViewStatesArray([...dummyArr]);
              }}
            />
          </TableCell>

           <TableCell sx={{ border: "1px solid #e0dada" }}>
            <Typography variant="body2"> Comment</Typography>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              onChange={(e) => {
                let dummyArr = addViewStatesArray;
                dummyArr[index] = {
                  ...dummyArr[index],
                  comment: e.target.value,
                };
                setAddViewStatesArray([...dummyArr]);
              }}
            />
          </TableCell>
    </TableRow>
  </TableBody>
</Table>

    </TableContainer>

          </Grid>
        {isNewItemOpen && (
          <>
            {" "}
            <Grid item xs={12} style={{ position: "relative" }}>
              <Typography
                variant="h3"
                align="center"
                style={{
                  color: "#777f87",
                  position: "absolute",
                  top: "10px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  backgroundColor: "#fafafb",
                  padding: "0 10px",
                }}
              >
                New Item Details
              </Typography>
            </Grid>
            <Grid
              container
              spacing="12px"
              style={{
                border: "1px solid #dbd9d9",
                borderRadius: "20px",
                marginTop: "30px",
                padding: "20px",
                boxShadow: "2px 4px 8px rgba(0, 0, 0, 0.2)",
              }}
            >
              <Grid container xs={12} spacing="8px">
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Enter Tobacco Code</Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    onChange={(e) =>
                      setItem({
                        ...item,
                        tobaccoCode: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Enter Sales Grade</Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    onChange={(e) =>
                      setItem({
                        ...item,
                        salesGrade: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Enter Buying Grade</Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    onChange={(e) =>
                      setItem({
                        ...item,
                        buyingGrade: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Internal Grade</Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    onChange={(e) =>
                      setItem({
                        ...item,
                        internalGrade: e.target.value,
                      })
                    }
                  />
                </Grid>

                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Origin</Typography> 
                  <FilterSelect
                    menuType="origin"
                    value={item?.origin || ""}
                    onChange={(e) => {
                      const newTerm = e.target.value || "";
                      setItem({
                        ...item,
                        origin: newTerm,
                      });
                    }}
                    fullWidth
                  />
                </Grid>

                {(item?.origin ==="China") && (
                  <Grid item xs={12} sm={2}>
                    <Typography variant="body2">Province</Typography>
                    <TextField
                      variant="outlined"
                      size="small"
                      fullWidth
                      onChange={(e) =>
                        setItem({
                          ...item,
                          province: e.target.value,
                        })
                      }
                    />
                  </Grid>
                )}

                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Type</Typography>
                   <FilterSelect
                         menuType="type"
                         value={item?.type}
                         onChange={(e) =>
                           setItem({
                            ...item,
                            type: e.target.value,
                          })
                         }
                         fullWidth
                       />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Leaf Form</Typography>
                    <FilterSelect
                                      menuType="leafForm"
                                      value={item?.leafForm}
                                      onChange={(e) =>
                                        setItem({ ...item, leafForm: e.target.value })
                                      }
                                      fullWidth
                                    />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Select Color</Typography>
                  <FilterSelect
                                     menuType="color"
                                     value={item?.color}
                                     onChange={(e) =>
                                       setItem({ ...item, color: e.target.value })
                                     }
                                     fullWidth
                                   />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Enter Crop Year</Typography>
                  <TextField
                    size="small"
                    fullWidth
                    onChange={(e) =>
                      setItem({
                        ...item,
                        crop: e.target.value,
                      })
                    }
                  />
                </Grid>
              
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Nicotine</Typography>
                  <TextField
                    size="small"
                    type="number"
                    fullWidth
                    onWheel={(e) => e.target.blur()}
                    onChange={(e) =>
                      setItem({
                        ...item,
                        nicotine: e.target.value,
                      })
                    }
                  />
                </Grid>

                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Sugar</Typography>
                  <TextField
                    size="small"
                    type="number"
                    fullWidth
                    variant="outlined"
                    onWheel={(e) => e.target.blur()}
                    onChange={(e) =>
                      setItem({
                        ...item,
                        sugar: e.target.value,
                      })
                    }
                  />
                </Grid>

                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Moisture</Typography>
                  <TextField
                    size="small"
                    type="number"
                    fullWidth
                    variant="outlined"
                    value={item?.moisture}
                    onWheel={(e) => e.target.blur()}
                    onChange={(e) =>
                      setItem({
                        ...item,
                        moisture: e.target.value,
                      })
                    }
                  />
                </Grid>
              </Grid>

              <Grid item xs={12} sm={2}>
                <Button
                  variant="outlined"
                  size="small"
                  sx={{ ml: 1.5, mt: 4, mr: 1 }}
                  onClick={() => {
                    setIsNewItemOpen(false);
                    setItem([]);
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  sx={{ mt: 4 }}
                  onClick={() => {
                    createItemApi(item)
                      .then((response) => {
                        toast.success("Item added successfully.");
                      })
                      .catch((error) => {
                        toast.error("Something Went Wrong.");
                      });
                    setIsNewItemOpen(false);
                    setItem([]);
                  }}
                >
                  Create Item
                </Button>
              </Grid>
            </Grid>{" "}
          </>
        )}
        {isEditItemOpen && (
          <>
            {" "}
            <Grid item xs={12} style={{ position: "relative" }}>
              <Typography
                variant="h3"
                align="center"
                style={{
                  color: "#777f87",
                  position: "absolute",
                  top: "10px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  backgroundColor: "#fafafb",
                  padding: "0 10px",
                }}
              >
                Edit Item {item?.id} Details
              </Typography>
            </Grid>
            <Grid
              container
              spacing="12px"
              style={{
                border: "1px solid #dbd9d9",
                borderRadius: "20px",
                marginTop: "30px",
                padding: "20px",
                boxShadow: "2px 4px 8px rgba(0, 0, 0, 0.2)",
              }}
            >
              <Grid container xs={12} spacing="8px">
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Enter Tobacco Code</Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={item?.tobaccoCode || ""}
                    onChange={(e) =>
                      setItem({
                        ...item,
                        tobaccoCode: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Enter Sales Grade</Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={item?.salesGrade || ""}
                    onChange={(e) =>
                      setItem({
                        ...item,
                        salesGrade: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Enter Buying Grade</Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={item?.buyingGrade || ""}
                    onChange={(e) =>
                      setItem({
                        ...item,
                        buyingGrade: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Internal Grade</Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={item?.internalGrade || ""}
                    onChange={(e) =>
                      setItem({
                        ...item,
                        internalGrade: e.target.value,
                      })
                    }
                  />
                </Grid>

                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Select Origin</Typography>
                                <FilterSelect
                    menuType="origin"
                    value={item?.origin || ""}
                    onChange={(e) => {
                      const newTerm = e.target.value || "";
                      setItem({
                        ...item,
                        origin: newTerm,
                      });
                    }}
                    fullWidth
                  />
                </Grid>

                {(item?.origin === "China") && (
                  <Grid item xs={12} sm={2}>
                    <Typography variant="body2">Province</Typography>
                    <TextField
                      variant="outlined"
                      size="small"
                      fullWidth
                      value={item?.province || ""}
                      onChange={(e) =>
                        setItem({
                          ...item,
                          province: e.target.value,
                        })
                      }
                    />
                  </Grid>
                )}

                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Type</Typography>
                   <FilterSelect
                          menuType="type"
                          value={item?.type || ""}
                          onChange={(e) =>
                            setItem({
                              ...item,
                              type: e.target.value,
                            })
                          }
                          fullWidth
                        />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Leaf Form</Typography>
                 <FilterSelect
                                     menuType="leafForm"
                                     value={item?.leafForm || ""}
                                     onChange={(e) =>
                                       setItem({ ...item, leafForm: e.target.value })
                                     }
                                     fullWidth
                                   />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Select Color</Typography>
                  <FilterSelect
                                     menuType="color"
                                     value={item?.color || ""}
                                     onChange={(e) =>
                                       setItem({ ...item, color: e.target.value })
                                     }
                                     fullWidth
                                   />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Crop Year</Typography>
                  <TextField
                    size="small"
                    fullWidth
                    value={item?.crop || ""}
                    onChange={(e) =>
                      setItem({
                        ...item,
                        crop: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Current Location</Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    id="outlined-select-storage"
                    value={item?.storage || ""}
                    onChange={(e) =>
                      setItem({
                        ...item,
                        storage: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Nicotine</Typography>
                  <TextField
                    size="small"
                    type="number"
                    fullWidth
                    value={item?.nicotine || ""}
                    onWheel={(e) => e.target.blur()}
                    onChange={(e) =>
                      setItem({
                        ...item,
                        nicotine: e.target.value,
                      })
                    }
                  />
                </Grid>

                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Sugar</Typography>
                  <TextField
                    size="small"
                    type="number"
                    fullWidth
                    value={item?.sugar || ""}
                    variant="outlined"
                    onWheel={(e) => e.target.blur()}
                    onChange={(e) =>
                      setItem({
                        ...item,
                        sugar: e.target.value,
                      })
                    }
                  />
                </Grid>

                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Moisture</Typography>
                  <TextField
                    size="small"
                    type="number"
                    fullWidth
                    value={item?.moisture || ""}
                    variant="outlined"
                    onWheel={(e) => e.target.blur()}
                    onChange={(e) =>
                      setItem({
                        ...item,
                        moisture: e.target.value,
                      })
                    }
                  />
                </Grid>

                <Grid item xs={12} sm={2}>
                                 <Typography variant="body2">Record Status</Typography>
                                 <FilterSelect
                                   menuType="recordStatus"
                                   value={item?.status || ""}
                                   onChange={(e) =>
                                     setItem({
                                       ...item,
                                       status: e.target.value,
                                     })
                                   }
                                   fullWidth
                                 />
                               </Grid>
              </Grid>

              <Grid item xs={12} sm={2}>
                <Button
                  variant="outlined"
                  size="small"
                  sx={{ ml: 1.5, mt: 4, mr: 1 }}
                  onClick={() => {
                    setIsEditItemOpen(false);
                    setItem([]);
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  sx={{ mt: 4 }}
                  onClick={() => {
                    updateItemApi(item.id, item)
                      .then((response) => {
                        toast.success("Item edited successfully.");
                      })
                      .catch((error) => {
                        toast.error("Something went wrong.");
                      });
                    setIsEditItemOpen(false);
                    setItem([]);
                  }}
                >
                  Save Item
                </Button>
              </Grid>
            </Grid>{" "}
          </>
        )}

        {isNewSampleOpen && (
          <>
            {" "}
            <Grid item xs={12} style={{ position: "relative" }}>
              <Typography
                variant="h3"
                align="center"
                style={{
                  color: "#777f87",
                  position: "absolute",
                  top: "10px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  backgroundColor: "#fafafb",
                  padding: "0 10px",
                }}
              >
                New Sample Details
              </Typography>
            </Grid>
            <Grid
              container
              spacing="12px"
              style={{
                border: "1px solid #dbd9d9",
                borderRadius: "20px",
                marginTop: "30px",
                padding: "20px",
                boxShadow: "2px 4px 8px rgba(0, 0, 0, 0.2)",
              }}
            >
              <Grid container xs={12} spacing="8px">
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Sample Purpose</Typography>
                      <FilterSelect
                         menuType="samplePurposes"
                         value={sample?.purpose}
                         error={!sample?.purpose}
                         helperText={!sample?.purpose ? "Sample purpose is required" : ""}
                         onChange={(e) =>
                           setSample({
                             ...sample,
                             purpose: e.target.value,
                           })
                         }
                         fullWidth
                       />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Item</Typography>
                  <Autocomplete
                    options={items}
                    getOptionLabel={(option) =>
                      `ID: ${option.id || ""} - Buying Grade: ${option.buyingGrade || ""
                      } - Sales Grade: ${option.salesGrade || ""} - Origin: ${option?.origin || ""} - Crop: ${option.crop || ""
                      }`
                    }
                    value={sample?.itemId}
                    onChange={(event, newValue) => {
                      setSample({
                        ...sample,
                        itemId: newValue ? newValue.id : null,
                      });
                    }}
                    onOpen={retrieveItems}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        size="small"
                        fullWidth
                      />
                    )}
                    renderTags={() => null}
                  />
                  {sample?.itemId && (
                    <Box mt={2}>
                      <Chip
                        label={`ID: ${items.find((item) => item.id === sample?.itemId)
                            ?.id || ""
                          }`}
                        style={{ marginBottom: "5px" }}
                        onDelete={() =>
                          setSample({
                            ...sample,
                            itemId: null,
                          })
                        }
                      />
                      <br />
                      <Chip
                        label={`Buying Grade: ${items.find((item) => item.id === sample?.itemId)
                            ?.buyingGrade || ""
                          }`}
                        style={{ marginBottom: "5px" }}
                      />
                      <br />
                      <Chip
                        label={`Sales Grade: ${items.find((item) => item.id === sample?.itemId)
                            ?.salesGrade || ""
                          }`}
                        style={{ marginBottom: "5px" }}
                      />
                      <br />
                      <Chip
                        label={`Crop: ${items.find((item) => item.id === sample?.itemId)
                            ?.crop || ""
                          }`}
                        style={{ marginBottom: "5px" }}
                      />
                      <br />
                    </Box>
                  )}
                </Grid>

                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Sample Image Link</Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    onChange={(e) =>
                      setSample({
                        ...sample,
                        image: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Sender</Typography>
                  <Autocomplete
                    options={stakeholders}
                    getOptionLabel={(option) =>
                      `${option.id || ""} - ${option.type || ""} - ${option.name || ""
                      }`
                    }
                    value={sample?.senderId}
                    onChange={(event, newValue) => {
                      setSample({
                        ...sample,
                        senderId: newValue ? newValue.id : null,
                      });
                    }}
                    onOpen={retrieveStakeholders}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        size="small"
                        fullWidth
                      />
                    )}
                    renderTags={() => null}
                  />
                  {sample?.senderId && (
                    <Box mt={2}>
                      <Chip
                        label={`ID: ${stakeholders.find(
                          (stakeholder) =>
                            stakeholder.id === sample?.senderId,
                        )?.id || ""
                          }`}
                        style={{ marginBottom: "5px" }}
                        onDelete={() =>
                          setSample({
                            ...sample,
                            senderId: null,
                          })
                        }
                      />
                      <br />
                      <Chip
                        label={`Type: ${stakeholders.find(
                          (stakeholder) =>
                            stakeholder.id === sample?.senderId,
                        )?.type || ""
                          }`}
                        style={{ marginBottom: "5px" }}
                      />
                      <br />
                      <Chip
                        label={`Name: ${stakeholders.find(
                          (stakeholder) =>
                            stakeholder.id === sample?.senderId,
                        )?.name || ""
                          }`}
                        style={{ marginBottom: "5px" }}
                      />
                      <br />
                    </Box>
                  )}
                </Grid>

                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Receiver</Typography>
                  <Autocomplete
                    options={stakeholders}
                    getOptionLabel={(option) =>
                      `${option.id || ""} - ${option.type || ""} - ${option.name || ""
                      }`
                    }
                    value={sample?.receiverId}
                    onChange={(event, newValue) => {
                      setSample({
                        ...sample,
                        receiverId: newValue ? newValue.id : null,
                      });
                    }}
                    onOpen={retrieveStakeholders}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        size="small"
                        fullWidth
                      />
                    )}
                    renderTags={() => null}
                  />
                  {sample?.receiverId && (
                    <Box mt={2}>
                      <Chip
                        label={`ID: ${stakeholders.find(
                          (stakeholder) =>
                            stakeholder.id === sample?.receiverId,
                        )?.id || ""
                          }`}
                        style={{ marginBottom: "5px" }}
                        onDelete={() =>
                          setSample({
                            ...sample,
                            receiverId: null,
                          })
                        }
                      />
                      <br />
                      <Chip
                        label={`Type: ${stakeholders.find(
                          (stakeholder) =>
                            stakeholder.id === sample?.receiverId,
                        )?.type || ""
                          }`}
                        style={{ marginBottom: "5px" }}
                      />
                      <br />
                      <Chip
                        label={`Name: ${stakeholders.find(
                          (stakeholder) =>
                            stakeholder.id === sample?.receiverId,
                        )?.name || ""
                          }`}
                        style={{ marginBottom: "5px" }}
                      />
                      <br />
                    </Box>
                  )}
                </Grid>

                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Number Of Samples</Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    fullWidth
                    value={sample?.numberOfSamples || ""}
                    onChange={(e) =>
                      setSample({
                        ...sample,
                        numberOfSamples: e.target.value,
                      })
                    }
                  />
                </Grid>

                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Net Weight Per Sample</Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    fullWidth
                    value={sample?.netWeightPerSample || ""}
                    onChange={(e) =>
                      setSample({
                        ...sample,
                        netWeightPerSample: e.target.value,
                      })
                    }
                  />
                </Grid>

                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Enter Sales Grade</Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    onChange={(e) =>
                      setSample({
                        ...sample,
                        salesGrade: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Enter Sales Nicotine</Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    type="number"
                    fullWidth
                    onWheel={(e) => e.target.blur()}
                    onChange={(e) =>
                      setSample({
                        ...sample,
                        salesNicotine: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Enter Sales Sugar</Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    type="number"
                    fullWidth
                    onWheel={(e) => e.target.blur()}
                    onChange={(e) =>
                      setSample({
                        ...sample,
                        salesSugar: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Enter Sales Moisture</Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    type="number"
                    fullWidth
                    onWheel={(e) => e.target.blur()}
                    onChange={(e) =>
                      setSample({
                        ...sample,
                        salesMoisture: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Enter Sales Origin</Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    onChange={(e) =>
                      setSample({
                        ...sample,
                        salesOrigin: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Enter Sales Crop</Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    onChange={(e) =>
                      setSample({
                        ...sample,
                        salesCrop: e.target.value,
                      })
                    }
                  />
                </Grid>

                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">
                    Enter Date Of Delivery
                  </Typography>
                  <TextField
                    size="small"
                    fullWidth
                    variant="outlined"
                    id="date"
                    type="date"
                    inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onKeyDown={(e) => e.preventDefault()}
                    onChange={(e) =>
                      setSample({
                        ...sample,
                        deliveryDate: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Enter Date Of Receive</Typography>
                  <TextField
                    size="small"
                    fullWidth
                    variant="outlined"
                    id="date"
                    type="date"
                    inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onKeyDown={(e) => e.preventDefault()}
                    onChange={(e) =>
                      setSample({
                        ...sample,
                        receiveDate: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">
                    Enter Courier Information
                  </Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    onChange={(e) =>
                      setSample({
                        ...sample,
                        courier: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Enter AWB Number</Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    onChange={(e) =>
                      setSample({
                        ...sample,
                        awbNumber: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Enter Remark</Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    onChange={(e) =>
                      setSample({
                        ...sample,
                        remark: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">
                    Enter Customer Feedback
                  </Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    onChange={(e) =>
                      setSample({
                        ...sample,
                        customerFeedback: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Is Sample Approved</Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    onChange={(e) =>
                      setSample({
                        ...sample,
                        approved: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">
                    Enter SG Approval Status
                  </Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    onChange={(e) =>
                      setSample({
                        ...sample,
                        approvalStatus: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Sample Paid By</Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    onChange={(e) =>
                      setSample({
                        ...sample,
                        paidBy: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Status</Typography>
                  <FilterSelect
                    menuType="recordStatus"
                    value={sample?.status || ""}
                    onChange={(e) =>
                      setSample({
                        ...sample,
                        status: e.target.value,
                      })
                    }
                    fullWidth
                  />
                </Grid>
              </Grid>

              <Grid item xs={12} sm={2}>
                <Button
                  variant="outlined"
                  size="small"
                  sx={{ ml: 1.5, mt: 4, mr: 1 }}
                  onClick={() => {
                    setIsNewSampleOpen(false);
                    setSample([]);
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  sx={{ mt: 4 }}
                  onClick={() => {
                    createSampleApi(sample)
                      .then((response) => {
                        toast.success("Sample added successfully.");
                      })
                      .catch((error) => {
                        toast.error("Something Went Wrong.");
                      });
                    setIsNewSampleOpen(false);
                    setSample([]);
                  }}
                >
                  Create Sample
                </Button>
              </Grid>
            </Grid>{" "}
          </>
        )}
        {isEditSampleOpen && (
          <>
            {" "}
            <Grid item xs={12} style={{ position: "relative" }}>
              <Typography
                variant="h3"
                align="center"
                style={{
                  color: "#777f87",
                  position: "absolute",
                  top: "10px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  backgroundColor: "#fafafb",
                  padding: "0 10px",
                }}
              >
                Edit Sample {sample?.id} Details
              </Typography>
            </Grid>
            <Grid
              container
              spacing="12px"
              style={{
                border: "1px solid #dbd9d9",
                borderRadius: "20px",
                marginTop: "30px",
                padding: "20px",
                boxShadow: "2px 4px 8px rgba(0, 0, 0, 0.2)",
              }}
            >
              <Grid container xs={12} spacing="8px">
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2"> Sample Purpose</Typography>
                  <FilterSelect
                                     menuType="samplePurposes"
                                     value={sample?.purpose || ""}
                                     error={!sample?.purpose}
                                     helperText={!sample?.purpose ? "Sample purpose is required" : ""}
                                     onChange={(e) =>
                                       setSample({
                                         ...sample,
                                         purpose: e.target.value,
                                       })
                                     }
                                     fullWidth
                                   />
                </Grid>

                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Item</Typography>
                  <Autocomplete
                    options={items}
                    getOptionLabel={(option) =>
                      `ID: ${option.id || ""} - Buying Grade: ${option.buyingGrade || ""
                      } - Sales Grade: ${option.salesGrade || ""} - Origin: ${option?.origin || ""} - Crop: ${option.crop || ""
                      }`
                    }
                    value={sample?.item?.id}
                    onChange={(event, newValue) => {
                      setSample({
                        ...sample,
                        item: {
                          ...sample?.item,
                          id: newValue ? newValue.id : null,
                        },
                      });
                    }}
                    onOpen={retrieveItems}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        size="small"
                        fullWidth
                        label={
                          (sample?.item?.id || "") +
                          " " +
                          (sample?.item?.buyingGrade || "") +
                          " " +
                          (sample?.item?.salesGrade || "")
                        }
                      />
                    )}
                    renderTags={() => null}
                  />
                  {sample?.item?.id && (
                    <Box mt={2}>
                      <Chip
                        label={`ID: ${items.find((item) => item.id === sample?.item.id)
                            ?.id || ""
                          }`}
                        style={{ marginBottom: "5px" }}
                        onDelete={() =>
                          setSample({
                            ...sample,
                            item: {
                              ...sample?.item,
                              id: null,
                            },
                          })
                        }
                      />
                      <br />
                      <Chip
                        label={`Buying Grade: ${items.find((item) => item.id === sample?.item.id)
                            ?.buyingGrade || ""
                          }`}
                        style={{ marginBottom: "5px" }}
                      />
                      <br />
                      <Chip
                        label={`Sales Grade: ${items.find((item) => item.id === sample?.item.id)
                            ?.salesGrade || ""
                          }`}
                        style={{ marginBottom: "5px" }}
                      />
                      <br />
                      <Chip
                        label={`Crop: ${items.find((item) => item.id === sample?.item.id)
                            ?.crop || ""
                          }`}
                        style={{ marginBottom: "5px" }}
                      />
                      <br />
                    </Box>
                  )}
                </Grid>

                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Image URL</Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={sample?.image || ""}
                    onChange={(e) =>
                      setSample({
                        ...sample,
                        image: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Sender</Typography>
                  <Autocomplete
                    options={stakeholders}
                    getOptionLabel={(option) =>
                      `${option.id || ""} - ${option.type || ""} - ${option.name || ""
                      }`
                    }
                    value={sample?.sender?.id}
                    onChange={(event, newValue) => {
                      setSample({
                        ...sample,
                        sender: {
                          ...sample?.sender,
                          id: newValue ? newValue.id : null,
                        },
                      });
                    }}
                    onOpen={retrieveStakeholders}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        size="small"
                        fullWidth
                        label={
                          (sample?.sender?.id || "") +
                          " " +
                          (sample?.sender?.name || "")
                        }
                      />
                    )}
                    renderTags={() => null}
                  />
                  {sample?.sender?.id && (
                    <Box mt={2}>
                      <Chip
                        label={`ID: ${stakeholders.find(
                          (stakeholder) =>
                            stakeholder.id === sample?.sender.id,
                        )?.id || ""
                          }`}
                        style={{ marginBottom: "5px" }}
                        onDelete={() =>
                          setSample({
                            ...sample,
                            sender: {
                              ...sample?.sender,
                              id: null,
                            },
                          })
                        }
                      />
                      <br />
                      <Chip
                        label={`Type: ${stakeholders.find(
                          (stakeholder) =>
                            stakeholder.id === sample?.sender.id,
                        )?.type || ""
                          }`}
                        style={{ marginBottom: "5px" }}
                      />
                      <br />
                      <Chip
                        label={`Name: ${stakeholders.find(
                          (stakeholder) =>
                            stakeholder.id === sample?.sender.id,
                        )?.name || ""
                          }`}
                        style={{ marginBottom: "5px" }}
                      />
                      <br />
                    </Box>
                  )}
                </Grid>

                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Receiver</Typography>
                  <Autocomplete
                    options={stakeholders}
                    getOptionLabel={(option) =>
                      `${option.id || ""} - ${option.type || ""} - ${option.name || ""
                      }`
                    }
                    value={sample?.receiver?.id}
                    onChange={(event, newValue) => {
                      setSample({
                        ...sample,
                        receiver: {
                          ...sample?.receiver,
                          id: newValue ? newValue.id : null,
                        },
                      });
                    }}
                    onOpen={retrieveStakeholders}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        size="small"
                        fullWidth
                        label={
                          (sample?.receiver?.id || "") +
                          " " +
                          (sample?.receiver?.name || "")
                        }
                      />
                    )}
                    renderTags={() => null}
                  />
                  {sample?.receiver?.id && (
                    <Box mt={2}>
                      <Chip
                        label={`ID: ${stakeholders.find(
                          (stakeholder) =>
                            stakeholder.id === sample?.receiver.id,
                        )?.id || ""
                          }`}
                        style={{ marginBottom: "5px" }}
                        onDelete={() =>
                          setSample({
                            ...sample,
                            receiver: {
                              ...sample?.receiver,
                              id: null,
                            },
                          })
                        }
                      />
                      <br />
                      <Chip
                        label={`Type: ${stakeholders.find(
                          (stakeholder) =>
                            stakeholder.id === sample?.receiver.id,
                        )?.type || ""
                          }`}
                        style={{ marginBottom: "5px" }}
                      />
                      <br />
                      <Chip
                        label={`Name: ${stakeholders.find(
                          (stakeholder) =>
                            stakeholder.id === sample?.receiver.id,
                        )?.name || ""
                          }`}
                        style={{ marginBottom: "5px" }}
                      />
                      <br />
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Number Of Samples</Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    fullWidth
                    value={sample?.numberOfSamples || ""}
                    onChange={(e) =>
                      setSample({
                        ...sample,
                        numberOfSamples: e.target.value,
                      })
                    }
                  />
                </Grid>

                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Net Weight Per Sample</Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    fullWidth
                    value={sample?.netWeightPerSample || ""}
                    onChange={(e) =>
                      setSample({
                        ...sample,
                        netWeightPerSample: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Sales Grade</Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={sample?.salesGrade || ""}
                    onChange={(e) =>
                      setSample({
                        ...sample,
                        salesGrade: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Sales Nicotine</Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    type="number"
                    fullWidth
                    value={sample?.salesNicotine || ""}
                    onWheel={(e) => e.target.blur()}
                    onChange={(e) =>
                      setSample({
                        ...sample,
                        salesNicotine: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Sales Sugar</Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    type="number"
                    value={sample?.salesSugar || ""}
                    onWheel={(e) => e.target.blur()}
                    onChange={(e) =>
                      setSample({
                        ...sample,
                        salesSugar: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Sales Moisture</Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    type="number"
                    value={sample?.salesMoisture || ""}
                    onWheel={(e) => e.target.blur()}
                    onChange={(e) =>
                      setSample({
                        ...sample,
                        salesMoisture: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Sales Origin</Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={sample?.salesOrigin || ""}
                    onChange={(e) =>
                      setSample({
                        ...sample,
                        salesOrigin: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Sales Crop</Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    type="number"
                    fullWidth
                    value={sample?.salesCrop || ""}
                    onWheel={(e) => e.target.blur()}
                    onChange={(e) =>
                      setSample({
                        ...sample,
                        salesCrop: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Date Of Delivery</Typography>
                  <TextField
                    id="date"
                    type="date"
                    onKeyDown={(e) => e.preventDefault()}
                    inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={
                      sample?.deliveryDate
                        ? format(parseISO(sample?.deliveryDate), "yyyy-MM-dd")
                        : ""
                    }
                    onChange={(e) =>
                      setSample({
                        ...sample,
                        deliveryDate: e.target.value
                          ? e.target.value + "T00:00:00.000+00:00"
                          : null,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Date Of Receive</Typography>
                  <TextField
                    id="date"
                    type="date"
                    onKeyDown={(e) => e.preventDefault()}
                    inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={
                      sample?.receiveDate
                        ? format(parseISO(sample?.receiveDate), "yyyy-MM-dd")
                        : ""
                    }
                    onChange={(e) =>
                      setSample({
                        ...sample,
                        receiveDate: e.target.value
                          ? e.target.value + "T00:00:00.000+00:00"
                          : null,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Courier</Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={sample?.courier || ""}
                    onChange={(e) =>
                      setSample({
                        ...sample,
                        courier: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">AWB Number</Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={sample?.awbNumber || ""}
                    onChange={(e) =>
                      setSample({
                        ...sample,
                        awbNumber: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Remark</Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={sample?.remark || ""}
                    onChange={(e) =>
                      setSample({
                        ...sample,
                        remark: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Customer Feedback</Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={sample?.customerFeedback || ""}
                    onChange={(e) =>
                      setSample({
                        ...sample,
                        customerFeedback: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Approved</Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={sample?.approved || ""}
                    onChange={(e) =>
                      setSample({
                        ...sample,
                        approved: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Approval Details</Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={sample?.approvalDetails || ""}
                    onChange={(e) =>
                      setSample({
                        ...sample,
                        approvalDetails: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2">Paid By</Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={sample?.paidBy || ""}
                    onChange={(e) =>
                      setSample({
                        ...sample,
                        paidBy: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2"> Status</Typography>
                  <FilterSelect
                    menuType="recordStatus"
                    value={sample?.status || ""}
                    onChange={(e) =>
                      setSample({
                        ...sample,
                        status: e.target.value,
                      })
                    }
                    fullWidth
                  />
                </Grid>
              </Grid>

              <Grid item xs={12} sm={2}>
                <Button
                  variant="outlined"
                  size="small"
                  sx={{ ml: 1.5, mt: 4, mr: 1 }}
                  onClick={() => {
                    setIsEditSampleOpen(false);
                    setSample([]);
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  sx={{ mt: 4 }}
                  onClick={() => {
                    updateSampleApi(sample?.id, sample)
                      .then((response) => {
                        toast.success("Sample edited successfully.");
                      })
                      .catch((error) => {
                        toast.error("Something went wrong.");
                        console.log(error.response.data);
                      });
                    setIsEditSampleOpen(false);
                    setSample([]);
                  }}
                >
                  Save Sample
                </Button>
              </Grid>
            </Grid>{" "}
          </>
        )}
      </Collapse>
    </>
  );
};

export default AddVendorOffer;
